import React, { useEffect, useRef } from "react";

interface YouTubeEmbedProps {
  videoId: string;
  className?: string;
  mobileHeight?: number;
  desktopHeight?: number;
}

const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({
  videoId,
  className = "",
  mobileHeight = 300,
  desktopHeight = 505,
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  // iOS-specific autoplay workaround
  useEffect(() => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    if (isIOS && iframeRef.current) {
      // For iOS, we may need to trigger play programmatically
      // This is a fallback approach
      const timer = setTimeout(() => {
        if (iframeRef.current) {
          // iOS often requires user interaction for autoplay
          // We'll reload the iframe with the same parameters
          const currentSrc = iframeRef.current.src;
          iframeRef.current.src = currentSrc;
        }
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [videoId]);
  return (
    <div
      className={`w-full ${className}`}
      style={{
        height: `${mobileHeight} ${desktopHeight}`,
      }}
    >
      <iframe
        ref={iframeRef}
        width="100%"
        height={`100%`}
        src={`https://www.youtube.com/embed/${videoId}?autoplay=1&playsinline=1&modestbranding=1&showinfo=0&rel=0&controls=0&disablekb=1&fs=0&iv_load_policy=3`}
        className="w-full h-[300px] md:h-[505px] rounded-12"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        // playsInline
        frameBorder="0"
      ></iframe>
    </div>
  );
};

export default YouTubeEmbed;
